/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetUsersOptions, AdminGetUsersStatus200, AdminGetUsersStatus422 } from '../models/AdminGetUsers'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetUsers } from '../clients/axios/adminGetUsers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetUsersQueryKey = ({ query }: Omit<AdminGetUsersOptions, 'headers'> = {}) => [{ url: '/admin/users' }, ...(query ? [query] : [])] as const

type AdminGetUsersQueryKey = ReturnType<typeof adminGetUsersQueryKey>

export function adminGetUsersQueryOptions({ query }: AdminGetUsersOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetUsersQueryKey({ query })
  return queryOptions<AdminGetUsersStatus200, ResponseErrorConfig<AdminGetUsersStatus422>, AdminGetUsersStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetUsers({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary List Users
 * {@link /admin/users}
 */
export function useAdminGetUsers<TData = AdminGetUsersStatus200, TQueryData = AdminGetUsersStatus200, TQueryKey extends QueryKey = AdminGetUsersQueryKey>({ query }: { query?: AdminGetUsersOptions['query'] | (() => AdminGetUsersOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<AdminGetUsersStatus200, ResponseErrorConfig<AdminGetUsersStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? adminGetUsersQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetUsersQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetUsersStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
